<div class="chat-app ai-chat-app">
  <Navbar />

  <div class="page-wrapper chat-page-wrapper ai-chat-page-wrapper d-flex flex-grow-1 overflow-hidden">
    <Sidebar />

    <div class="hero-section w-100 chat-section ai-chat-section d-flex flex-grow-1 overflow-hidden">
      <main
        class="chat-container chat-viewport-container ai-chat-shell p-0 w-100 d-flex flex-grow-1 overflow-hidden"
        :class="{ 'ai-list-collapsed': ai_list_collapsed }"
        aria-label="Ziva"
      >
      <aside class="conversations-sidebar ai-chat-list d-flex flex-column">
        <div class="ai-chat-list-header d-flex align-items-center justify-content-between">
          <div class="ai-brand-lockup d-flex align-items-center">
            <img :src="require('@/assets/ziva/ziva-logo-lockup.png')" alt="Ziva">
          </div>
          <div class="d-flex align-items-center gap-2">
            <button class="ai-icon-btn ai-focus-btn d-inline-flex align-items-center justify-content-center" type="button" title="Focus chat view" @click="toggle_ai_list">
              <i class="fas fa-up-right-and-down-left-from-center"></i>
            </button>
            <button class="ai-add-btn d-inline-flex align-items-center justify-content-center" type="button" title="Start new chat" @click="start_new_chat()">
              <i class="fas fa-plus"></i>
              <span>New</span>
            </button>
          </div>
        </div>

        <label class="ai-search d-flex align-items-center">
          <i class="fas fa-search"></i>
          <input v-model="search_query" class="form-control" type="search" placeholder="Search chats..." aria-label="Search chats">
        </label>

        <div class="ai-chat-groups flex-grow-1 overflow-auto">
          <div
            v-for="chat in filtered_chats"
            :key="chat.id"
            role="button"
            tabindex="0"
            class="ai-chat-item d-flex align-items-center text-start"
            :class="{ active: chat.id === active_chat_id, 'is-pinned': chat.pinned }"
            @click="select_chat(chat.id)"
            @keydown.enter.prevent="select_chat(chat.id)"
          >
            <span class="ai-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
              <img :src="require('@/assets/ziva/ziva-favicon.png')" alt="">
            </span>
            <span class="ai-chat-item-body flex-grow-1 overflow-hidden">
              <span class="ai-chat-item-title d-block text-truncate">
                <i v-if="chat.pinned" class="fas fa-thumbtack ai-pinned-icon"></i>
                {{ chat.title }}
              </span>
              <span class="ai-chat-item-preview d-block text-truncate">{{ chat.preview }}</span>
            </span>
            <span class="ai-chat-time flex-shrink-0">{{ chat.time }}</span>
            <button
              class="ai-chat-menu-trigger d-inline-flex align-items-center justify-content-center flex-shrink-0"
              type="button"
              title="Chat options"
              @click.stop="toggle_chat_menu(chat.id)"
            >
              <i class="fas fa-ellipsis-vertical"></i>
            </button>

            <div v-if="active_chat_menu_id === chat.id" class="ai-chat-menu" @click.stop>
              <button type="button" class="d-flex align-items-center gap-2 text-start" @click="toggle_pin_chat(chat.id)">
                <i class="fas fa-thumbtack"></i>
                {{ chat.pinned ? 'Unpin chat' : 'Pin chat' }}
              </button>
              <button type="button" class="d-flex align-items-center gap-2 text-start" @click="rename_chat(chat.id)">
                <i class="fas fa-pen"></i>
                Rename
              </button>
              <button type="button" class="danger d-flex align-items-center gap-2 text-start" @click="delete_chat(chat.id)">
                <i class="fas fa-trash"></i>
                Delete
              </button>
            </div>
          </div>
        </div>
      </aside>

      <section class="chat-panel ai-conversation d-flex flex-column overflow-hidden">
        <div class="ai-conversation-top d-none d-lg-flex align-items-center justify-content-between">
          <button
            v-if="ai_list_collapsed"
            type="button"
            class="ai-top-icon-btn d-inline-flex align-items-center justify-content-center"
            title="Show chats"
            @click="toggle_ai_list"
          >
            <i class="fas fa-table-columns"></i>
          </button>
          <div class="ai-model-pill d-inline-flex align-items-center gap-2">
            <span class="ai-model-mark d-inline-flex align-items-center justify-content-center">
              <img :src="require('@/assets/ziva/ziva-favicon.png')" alt="">
            </span>
            <div>
              <strong>Ziva</strong>
              <small>Workspace-aware</small>
            </div>
          </div>
          <div class="ai-top-actions d-inline-flex align-items-center gap-2"></div>
        </div>

        <div class="ai-mobile-header d-flex d-lg-none align-items-center gap-2">
          <button class="ai-mini-btn d-inline-flex align-items-center justify-content-center" type="button" aria-label="Show chat list" @click="show_mobile_list = true">
            <i class="fas fa-bars"></i>
          </button>
          <div>
            <strong class="d-block">{{ active_chat?.title || 'New chat' }}</strong>
            <span class="d-block">{{ active_chat ? 'Assistant chat' : 'Select a chat' }}</span>
          </div>
        </div>

        <div v-if="!active_chat" class="chat-welcome ai-chat-welcome d-flex align-items-center justify-content-center h-100">
          <div class="chat-welcome-card ai-home-card text-center">
            <div class="ai-welcome-icon d-flex align-items-center justify-content-center mx-auto">
              <img :src="require('@/assets/ziva/ziva-favicon.png')" alt="Ziva">
            </div>
            <h3>How can I help?</h3>
            <p>Ask about documents, projects, governance, or workspace activity.</p>
            <form class="ai-composer ai-home-composer d-flex align-items-end gap-2" @submit.prevent="start_chat_from_draft">
              <button class="ai-mini-btn d-inline-flex align-items-center justify-content-center" type="button" title="Attach file">
                <i class="fas fa-paperclip"></i>
              </button>
              <textarea
                ref="home_composer"
                v-model.trim="draft"
                rows="1"
                placeholder="Message Ziva..."
                @input="resize_home_composer"
                @keydown.enter.exact.prevent="start_chat_from_draft"
              ></textarea>
              <button class="ai-mini-btn d-inline-flex align-items-center justify-content-center" type="button" title="Use workspace context">
                <i class="fas fa-database"></i>
              </button>
              <button class="ai-send-btn d-inline-flex align-items-center justify-content-center" type="submit" :disabled="!draft" title="Send">
                <i class="fas fa-arrow-up"></i>
              </button>
            </form>
            <small class="mt-3 d-block"><i class="fas fa-lock me-1"></i>Secured with your AIC One workspace context</small>
          </div>
        </div>

        <template v-else>
          <div ref="message_scroller" class="ai-messages flex-grow-1 overflow-auto">
            <div v-if="active_chat.messages.length" class="ai-date-divider"><span>Today, 09:30 AM</span></div>

            <article
              v-for="message in active_chat.messages"
              :key="message.id"
              class="ai-message-row d-flex"
              :class="message.sender === 'user' ? 'from-user' : 'from-ai'"
            >
              <span v-if="message.sender === 'ai'" class="ai-avatar message-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
                <img :src="require('@/assets/ziva/ziva-favicon.png')" alt="">
              </span>
              <div class="ai-message-stack">
                <div class="ai-bubble" :class="message.sender === 'user' ? 'user-bubble' : 'assistant-bubble'">
                  <p v-for="line in message.lines" :key="line" class="mb-0">{{ line }}</p>
                  <pre v-if="message.code" class="ai-code-block"><code>{{ message.code }}</code></pre>
                  <div v-if="message.context" class="ai-inline-context d-flex align-items-center gap-2">
                    <i class="far fa-file-alt"></i>
                    <span>Context: <strong>{{ message.context }}</strong> - loaded from Documents</span>
                  </div>
                  <time>{{ message.time }}</time>
                </div>
                <div v-if="message.actions?.length" class="ai-message-actions d-flex flex-wrap gap-2">
                  <button v-for="action in message.actions" :key="action" type="button" @click="apply_suggestion(action)">
                    <i :class="action_icon(action)"></i>
                    {{ action }}
                  </button>
                </div>
              </div>
            </article>

            <article v-if="is_typing" class="ai-message-row from-ai d-flex">
              <span class="ai-avatar message-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
                <img :src="require('@/assets/ziva/ziva-favicon.png')" alt="">
              </span>
              <div class="ai-bubble assistant-bubble ai-typing" aria-label="Ziva is typing">
                <span></span><span></span><span></span>
              </div>
            </article>
          </div>

          <div class="ai-composer-dock">
            <form class="ai-composer d-flex align-items-end gap-2" @submit.prevent="send_message">
              <button class="ai-mini-btn d-inline-flex align-items-center justify-content-center" type="button" title="Attach file">
                <i class="fas fa-paperclip"></i>
              </button>
              <textarea
                ref="composer"
                v-model.trim="draft"
                rows="1"
                :placeholder="active_chat.messages.length ? 'Ask anything about your workspace...' : 'Start typing your first Ziva prompt...'"
                @input="resize_composer"
                @keydown.enter.exact.prevent="send_message"
              ></textarea>
              <button class="ai-mini-btn d-inline-flex align-items-center justify-content-center" type="button" title="Use workspace context">
                <i class="fas fa-database"></i>
              </button>
              <button class="ai-send-btn d-inline-flex align-items-center justify-content-center" type="submit" :disabled="!draft || is_typing" title="Send">
                <i class="fas fa-paper-plane"></i>
              </button>
            </form>
          </div>
        </template>
      </section>
      </main>
    </div>
  </div>

  <div v-if="show_mobile_list" class="ai-mobile-list-backdrop d-lg-none" @click.self="show_mobile_list = false">
    <div class="ai-mobile-list-panel">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <strong>Chats</strong>
          <button class="ai-mini-btn d-inline-flex align-items-center justify-content-center" type="button" @click="show_mobile_list = false"><i class="fas fa-times"></i></button>
      </div>
      <button
        v-for="chat in filtered_chats"
        :key="chat.id"
        type="button"
        class="ai-chat-item d-flex align-items-center text-start w-100"
        :class="{ active: chat.id === active_chat_id }"
        @click="select_chat(chat.id); show_mobile_list = false"
      >
        <span class="ai-avatar d-inline-flex align-items-center justify-content-center flex-shrink-0">
          <img :src="require('@/assets/ziva/ziva-favicon.png')" alt="">
        </span>
        <span class="ai-chat-item-body flex-grow-1 overflow-hidden">
          <span class="ai-chat-item-title d-block text-truncate">{{ chat.title }}</span>
          <span class="ai-chat-item-preview d-block text-truncate">{{ chat.preview }}</span>
        </span>
      </button>
    </div>
  </div>
</div>
